import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    UpdateMarkers();
}

var MapsBase64 = {

    // private property
    _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    // public method for encoding
    encode : function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = MapsBase64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

        }

        return output;
    },

    // public method for decoding
    decode : function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = MapsBase64._utf8_decode(output);

        return output;

    },

    // private method for UTF-8 encoding
    _utf8_encode : function (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    },

    // private method for UTF-8 decoding
    _utf8_decode : function (utftext) {
        var string = "";
        var i = 0;
        let c1 = 0;
        let c2 = 0;
        var c = 0;

        while ( i < utftext.length ) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if((c > 191) && (c < 224)) {
                let c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                let c2 = utftext.charCodeAt(i+1);
                let c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    }
}

function UpdateMarkers(mapId) {
    // check if map is already initialized
    if (!window.maps) {
        window.maps = [];
        window.mapsItem = [];
        window.mapsReady = [];
    }

    if (!window.mapsReady[mapId]) {
        initializeMap();
        return;
    }

    if (mapId) {
        let markers = JSON.parse(window.mapsItem[mapId].dataset.locations);

        const points = markers.map((marker) => ({
            type: 'Feature',
            properties: {
                markerId: marker.id,
                description: marker.description,
            },
            geometry: {
                type: 'Point',
                coordinates: [parseFloat(marker.geo.lng), parseFloat(marker.geo.lat)],
            },
        }));

        window.maps[mapId].addSource('Locations', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: points,
            },
            cluster: true,
            clusterRadius: 50,
        });

        window.maps[mapId].addLayer({
            id: 'single',
            type: 'symbol',
            source: 'Locations',
            filter: ['!=', 'cluster', true],
            layout: {
                'icon-image': 'marker' + mapId,
                'icon-size': parseFloat(window.mapsItem[mapId].dataset.iconSize)
            }
        });

        if (markers.length !== 1) {
            window.maps[mapId].addLayer({
                id: 'cluster',
                type: 'circle',
                source: 'Locations',
                filter: ['==', 'cluster', true],
                paint: {
                    'circle-color': window.mapsItem[mapId].dataset.clustercolor,
                    'circle-opacity': 1,
                    'circle-radius': 25,
                    'circle-stroke-color': window.mapsItem[mapId].dataset.clustercolor,
                    'circle-stroke-opacity': 0.25,
                    'circle-stroke-width': 10,
                },
            });

            window.maps[mapId].addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'Locations',
                filter: ['has', 'point_count'],
                paint: {
                    'text-color': window.mapsItem[mapId].dataset.clustertextcolor,
                },
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 18,
                },
            });

            window.maps[mapId].on('click', 'cluster', (e) => {
                const features = window.maps[mapId].queryRenderedFeatures(e.point, {
                    layers: ['cluster'],
                });
                const clusterId = features[0].properties.cluster_id;
                window.maps[mapId].getSource('Locations').getClusterExpansionZoom(clusterId, (err, zoom) => {
                    if (err) return;

                    window.maps[mapId].easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom,
                    });
                });
            });

            let markerCoordinatesGroup = [];
            points.forEach((marker) => {
                markerCoordinatesGroup.push(marker.geometry.coordinates);
            });

            window.maps[mapId].fitBounds(calcBoundsFromCoordinates(markerCoordinatesGroup), {
                padding: {top: 100, bottom: 100, left: 100, right: 100},
                duration: 0,
            });
        }

        window.maps[mapId].on('click', 'single', (e) => {
            let description = e.features[0].properties.description;

            if (description !== '') {
                description = MapsBase64.decode(description);
                const coordinates = e.features[0].geometry.coordinates.slice();

                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new mapboxgl.Popup()
                    .setLngLat(coordinates)
                    .setHTML(description)
                    .addTo(window.maps[mapId]);
            }
        });
    }
}

function initializeMap() {
    if (typeof mapboxgl !== 'undefined') {
        let mainElement = document.querySelector('[data-mapboxkey]');
        if (mainElement) {
            mapboxgl.accessToken = MapsBase64.decode(mainElement.dataset.mapboxkey);
            const mapElements = document.querySelectorAll('[paws-component="noss-map"][paws-template="default"] .mapbox');

            if (mapElements.length < 1) {
                return;
            }

            mapElements.forEach((mapItem) => {
                // Map initialization
                //const markers = JSON.parse(mapItem.dataset.markers);
                const mapId = mapItem.children[0].id;
                const style = mapItem.dataset.style;
                const zoom = mapItem.dataset.zoom;
                const longitude = mapItem.dataset.lng;
                const latitude = mapItem.dataset.lat;

                window.maps[mapId] = new mapboxgl.Map({
                    container: mapId,
                    style: style ? style : 'mapbox://styles/mapbox/streets-v11',
                    center: [longitude, latitude],
                    zoom: zoom
                });
                window.mapsItem[mapId] = mapItem;
                window.maps[mapId].scrollZoom.disable();
                window.maps[mapId].addControl(new mapboxgl.NavigationControl());

                window.maps[mapId].on('load', () => {
                    window.maps[mapId].loadImage(window.mapsItem[mapId].dataset.icon, (error, markerImage) => {
                        if (error) throw error;
                        window.maps[mapId].addImage('marker' + mapId, markerImage);
                        window.mapsReady[mapId] = true;
                        UpdateMarkers(mapId);
                    });
                });
            });
        }
    }
}

function getSWCoordinates(coordinatesCollection) {
    const lowestLng = Math.min(...coordinatesCollection.map((coordinates) => coordinates[0]));
    const lowestLat = Math.min(...coordinatesCollection.map((coordinates) => coordinates[1]));

    return [lowestLng, lowestLat];
}

function getNECoordinates(coordinatesCollection) {
    const highestLng = Math.max(...coordinatesCollection.map((coordinates) => coordinates[0]));
    const highestLat = Math.max(...coordinatesCollection.map((coordinates) => coordinates[1]));

    return [highestLng, highestLat];
}

function calcBoundsFromCoordinates(coordinatesCollection) {
    return [getSWCoordinates(coordinatesCollection), getNECoordinates(coordinatesCollection)];
}